import styled from '@emotion/styled';
import { css } from 'emotion';

import { getThemeColor, theme } from '@ezugi/ui/theme';

const { tints } = theme;
const commonStyle = css`
  display: inline-flex;
  justify-content: center;
  align-items: center;
`;
export const disabledClassName = css`
  :hover {
    > svg {
      color: ${getThemeColor('foreground')};
      fill: ${getThemeColor('foreground')};
    }
  }
  :active {
    > svg {
      color: ${getThemeColor('foreground')};
      fill: ${getThemeColor('foreground')};
    }
  }
`;
export const customColorClassName = css`
  > svg {
    color: inherit;
    fill: inherit;
  }
  :hover {
    > svg {
      color: inherit;
      fill: inherit;
    }
  }
  :active {
    > svg {
      color: inherit;
      fill: inherit;
    }
  }
`;
export const Container = styled.div`
  ${commonStyle};
  > svg {
    color: ${getThemeColor('foreground')};
    fill: ${getThemeColor('foreground')};
    width: 100%;
    height: 100%;
  }
  ${({ isHandheld } : { isHandheld : boolean}) => !isHandheld
    && css`
      :hover {
        > svg {
          color: ${getThemeColor('accent')};
          fill: ${getThemeColor('accent')};
        }
      }
    `};
  :active {
    > svg {
      fill: ${getThemeColor('accent', tints.primary)};
      color: ${getThemeColor('accent', tints.primary)};
    }
  }
`;
export const ContainerWithoutTheme = styled.div`
  ${commonStyle};
  > svg {
    width: 100%;
    height: 100%;
  }
`;
